export default {
  meta: {
    title: "DADABIO イノベーションテクノロジー",
    desc: "DADABIOはイスタンブール本拠のR&D主導ソフトウェアエンジニアリング企業。高性能エンタープライズソフトウェア、先進AIエコシステム、安全な越境デジタルプラットフォームをグローバル企業に提供します。",
  },
  nav: { vision: "ビジョン", services: "サービス", contact: "お問い合わせ", cta: "プロジェクトを始める" },
  hero: {
    badge: "イスタンブール → グローバル · R&Dエンジニアリングハウス",
    lines: ["DADABIO", "イノベーション", "テクノロジー"],
    subtitle: "グローバル企業向けに、高性能なエンタープライズソフトウェア、先進的なAIエコシステム、安全な越境デジタルプラットフォームを設計・構築します。",
    ctaPrimary: "サービスを見る",
    ctaSecondary: "プロジェクトを始める",
    scroll: "スクロール",
  },
  marquee: ["エンタープライズソフトウェア", "AIエコシステム", "越境プラットフォーム", "ゼロトラストセキュリティ", "先進研究開発", "グローバルスケール"],
  vision: {
    label: "Kurumsal Vizyon — Corporate Vision",
    heading: "グローバルビジネスの見えないインフラを構築する",
    p1: "DADABIOはイスタンブールに本社を置くR&D主導のソフトウェアエンジニアリング企業であり、人工知能、エンタープライズシステム、越境デジタルインフラの交差点で事業を展開しています。私たちは技術サイクルを追いません。その先に来るものを自ら設計します。",
    p2: "私たちが提供するすべてのプラットフォームは、3つの妥協なき原則の上に築かれています。スケールでの性能、設計によるセキュリティ、測定可能なビジネスインパクト。グローバル市場に参入するスタートアップからレガシー資産を近代化する大企業まで、野心的なビジョンを本番運用レベルの現実へと変えます。",
    chapters: [
      { num: "01", title: "中核にあるR&D", text: "DADABIOにおいて研究は部門ではなく、オペレーティングシステムです。私たちのエンジニアは、新興技術が製品ロードマップに到達するはるか前に、プロトタイプを作り、ベンチマークを取り、堅牢化します。" },
      { num: "02", title: "イノベーション駆動型の構造", text: "少人数で熟練した自律的なチーム。アイデアとデプロイの間に官僚主義はありません。この構造により、スタートアップのスピードとエンタープライズの規律を両立させています。" },
      { num: "03", title: "グローバルトランスフォーメーション", text: "ハイテク統合を通じて、グローバル企業の運営方法を再構築します。市場、通貨、データを一貫したひとつのデジタル生命体へと接続します。" },
    ],
    stats: [
      { value: "6+", label: "グローバル市場" },
      { value: "120+", label: "エンタープライズ導入" },
      { value: "99.9%", label: "稼働率 SLA" },
      { value: "24/7", label: "セキュリティ監視" },
    ],
  },
  services: {
    label: "私たちの仕事",
    heading: "6つの領域。ひとつの執念。",
    sub: "各領域をクリックすると、詳細な能力概要が開きます。",
    items: [
      { num: "01", title: "エンタープライズアプリケーションサポート", tagline: "ミッションクリティカルなシステムの全ライフサイクル支援", detail: "ミッションクリティカルな業務アプリケーションを全ライフサイクルにわたって運用します。プロアクティブなインシデント対応とSLA管理のサービスデスクから、クラウド移行、継続的なパフォーマンス最適化まで。お客様のシステムは常に高速かつ安定し、需要の一歩先を行きます。", points: ["全ライフサイクルの技術サポート", "SLAトラッキングとレポート", "クラウド移行アーキテクチャ", "継続的なシステム最適化"] },
      { num: "02", title: "先進技術R&D", tagline: "カスタムLLM、視覚システム、ディープテック", detail: "私たちの研究ラボは、カスタムLLMアーキテクチャを設計し、機械学習モデルを微調整し、生データを決定的な優位性へと変えるコンピュータビジョンパイプラインを構築します。本番環境のために設計されたディープテック・イノベーションです。", points: ["カスタムLLMアーキテクチャ", "MLモデルのファインチューニング", "コンピュータビジョンシステム", "ディープテックのプロトタイピング"] },
      { num: "03", title: "国際Eコマース", tagline: "国境のない商取引をグローバル規模で", detail: "多通貨決済パイプライン、ローカライズされたストアフロント、グローバルなデジタル貿易ロジスティクスを備えた、大容量の越境コマースプラットフォームを構築します。摩擦なく市場間をスケールするために設計されています。", points: ["越境コマースアーキテクチャ", "多通貨決済パイプライン", "グローバル貿易ロジスティクス", "ローカライズされたストアフロント"] },
      { num: "04", title: "カスタムソフトウェアエンジニアリング", tagline: "本番品質のプラットフォームを、長く使える形で", detail: "スケーラブルなマイクロサービス、精密なバックエンドエンジニアリング、堅牢なAPI開発。お客様の企業とともに成長する、安全で本番運用可能なアーキテクチャとして提供します。", points: ["スケーラブルなマイクロサービス", "バックエンドシステム工学", "API設計と開発", "本番品質のデリバリー"] },
      { num: "05", title: "デジタルトランスフォーメーション", tagline: "レガシープロセスからインテリジェントシステムへ", detail: "ワークフロー自動化、応用データサイエンス、戦略的技術統合により企業のオペレーションを再構築し、レガシーなプロセスをインテリジェントで測定可能なシステムへと変革します。", points: ["エンタープライズワークフロー自動化", "データサイエンス実装", "戦略的技術統合", "レガシーモダナイゼーション"] },
      { num: "06", title: "サイバーセキュリティとクラウド運用", tagline: "ゼロトラスト防御、常時稼働のオペレーション", detail: "ゼロトラストネットワークの展開、暗号化されたクラウドアーキテクチャ、24時間365日のアクティブ監視により、お客様のインフラを強靭に保ちます。リスクが影響になる前に検知します。", points: ["ゼロトラスト展開", "暗号化クラウドアーキテクチャ", "リスク低減", "24/7サーバー監視"] },
    ],
  },
  contact: {
    label: "お問い合わせ",
    heading: "次なるものを、共に築きましょう。",
    sub: "プロジェクトについてお聞かせください。シニアエンジニアが1営業日以内に返信します。",
    namePlaceholder: "氏名",
    emailPlaceholder: "法人メールアドレス",
    subjectPlaceholder: "件名",
    messagePlaceholder: "プロジェクトについてお聞かせください...",
    send: "メッセージを送信",
    sending: "送信中...",
    successTitle: "メッセージを受信しました。",
    successMsg: "1営業日以内にチームから返信いたします。",
    error: "エラーが発生しました。もう一度お試しください。",
  },
  footer: {
    tagline: "グローバルビジネスのデジタルインフラを設計する。",
    hq: "Rumeli Cad. No 7/4 Basaksehir / Istanbul - TURKIYE",
    duns: "D-U-N-S®: 75-116-1145",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    rights: "© 2026 DADABIO İnovasyon Teknoloji. 無断転載を禁じます。",
  },
};
